import { gantt, Gantt } from "./dhtmlxgantt.web";
import scope from "./utils/global";

(scope as any).gantt = gantt;
(scope as any).Gantt = Gantt;

export default gantt;

export { gantt, Gantt };

// Template security helpers consumed by the framework wrappers (see
// sources/utils/template_security.ts). Exported here so the React, Angular and
// Vue wrappers share a single implementation.
export {
	escapeHTML,
	allowRawHTML,
	basicSanitizeHTML,
	applyTemplatePolicy
} from "./utils/template_security";
export type { HtmlTemplatePolicy } from "./utils/template_security";